import React from 'react'
import imgSerbiahorizontal from '../../assets/Serbiahorizontal.png'
import './Horizontal.css'
import { Col, Row } from 'react-bootstrap'

const Horizontal = () => {
    return (
        <div className="horizontalImageBody">
            <img src={imgSerbiahorizontal} alt="FranceImage" className="responsive-image" />
        </div>
    )
}

export default Horizontal